import styled, { css } from 'styled-components';

import {
  addDesktopDesignStyle,
  CASTING_BUTTON_RIGHT_MARGIN,
  getSpacing,
  NAV_BAR_HEIGHT,
} from 'stylesheetB2c';

export const FloatingButtonContainer = styled.div`
  display: none;
  ${addDesktopDesignStyle(css`
    /*
    Temporarily remove remote button display on desktop mode as well , to handle bug in production
    */
    position: absolute;
    bottom: calc(${getSpacing(2)} + ${NAV_BAR_HEIGHT});
    right: ${CASTING_BUTTON_RIGHT_MARGIN};
  `)}
`;
FloatingButtonContainer.displayName = 'FloatingButtonContainer';
